export default {
    state: () => ({}),
    mutations: {}
}